document.addEventListener('DOMContentLoaded', function() {
    const collapsibleSections = document.querySelectorAll('.collapsible-section-item');
   
    collapsibleSections.forEach(item => {
        const header = item.querySelector('.collapsible-section-item-header');
        const icon = item.querySelector('.collapsible-section-item-icon');
        header.addEventListener('click', function() {
            const content = item.querySelector('.collapsible-section-item-content');
            content.classList.toggle('active');
            icon.classList.toggle('active');
        });
    });


});